//@flow
import {take, put, call} from 'redux-saga/effects'
import {mapActions} from '../actions'
import {watchLocation} from '../channels/watchLocation'

export function * watchLocationEffect(): Effect {
  const locationChannel = yield call(watchLocation, 60000)
  while (true) {
    const location: Position = yield take(locationChannel)
    yield put(mapActions.setLocation({latitude: location.coords.latitude, longitude: location.coords.longitude}))
  }
}
